/**
 * Highlight the searchValue and return the highlighted text node
 * @param {any} searchValue - Search value
 * @param {any} text - Text content
 * @returns {any} The highlighted text node
 */
const HighlightText = (searchValue: string | null, text: string): React.ReactNode => {
  if (!searchValue || !text) return text;

  // Search text is user input; escape regex syntax so values like (+91) are literal.
  const escapedSearchValue = searchValue.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`(${escapedSearchValue})`, 'gi');
  const parts = text.split(regex);

  return parts.map((part, index) =>
    part.toLocaleLowerCase() === searchValue.toLocaleLowerCase() ? (
      <span key={index} className="highlight">
        {part}
      </span>
    ) : (
      part
    ),
  );
};

export default HighlightText;
